import AHeading from './index.vue';

AHeading.install = app => {
  app.component(AHeading.name, AHeading);
};

export default AHeading;
